var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resolvedDealId)?_c('div',{staticClass:"stock-deal-reference mt-1"},[_c('router-link',{staticClass:"text-caption",attrs:{"to":{ name: 'deals-view', params: { id: _vm.resolvedDealId } }}},[_c('v-icon',{staticClass:"mr-1",attrs:{"x-small":""}},[_vm._v("mdi-briefcase-outline")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }